import request from '@/utils/request';
import {
  endpoints,
} from '@/constants/urls';

const metrics = (entities = []) => {
  // Params without values not supported until axios 1.0.0 released, so set all true.
  // See https://github.com/axios/axios/pull/1987.
  const params = entities.reduce((acc, entity) => Object.assign(acc, { [entity]: true }), {});
  return request({
    url: endpoints.METRICS,
    method: 'GET',
    params,
  });
};

const MetricsService = {
  metrics,
};

export default MetricsService;
